/** @jsx jsx */
// eslint-disable-next-line no-unused-vars
import { jsx } from '@emotion/core';

import { dlsWhite, Heading } from '@americanexpress/dls-react'; // eslint-disable-line no-unused-vars
import registerStyles from '../../../styles/registerStyles';

const Banner = () => (
  <div className="pad">
    <Heading level={1} headingStyle="heading6" theme={dlsWhite}>
      Let’s sign up with File Exchange Express.
    </Heading>
    <p css={registerStyles['.bannerText']}>
      Signing up for FileXpress is fast and free.
    </p>
  </div>
);

export default Banner;
